import { formatReward } from "./instant-data";
import PrimaryButton from "./primary-button";

export default function Approved({ amount, onContinue }) {
  const reward = formatReward(amount) || "reward";
  return (
    <section className="ir-hero-status">
      <div className="ir-check-badge" aria-hidden="true">
        <svg width="28" height="28" viewBox="0 0 28 28">
          <path d="M7 14.5 12 19.5 21 9" fill="none" stroke="#171B26" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <h1 className="ir-display">
        {amount != null ? (
          <>
            <span className="ir-display-accent">{formatReward(amount)}</span> IS IN.
          </>
        ) : (
          "YOU'RE IN."
        )}
      </h1>
      <p className="ir-hero-copy">
        Your account is open and your {reward} is ready to spend, save, or cash out.
      </p>
      <PrimaryButton onClick={onContinue}>Continue</PrimaryButton>
    </section>
  );
}
